import Vue from "vue";

// initial state
const state = ß.QUERY_FILTERS;

// mutations
const mutations = {};

const getters = {
    // Access with $store.getters["database/getDatabaseList"]
    getQueryFilterComponent: (state, getters) => (key) => {
        if (!key) return {};
        const element = ß.QUERY_FILTERS[key];
        if (!element) return {};
        return element;
    },
    getContextFilterComponent: (state, getters) => (key) => {
        if (!key) return {};
        const element = ß.CONTEXT_FILTERS[key];
        if (!element) return {};
        return element;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};
